const SHOP_TYPE = {
  wholesale: 'wholesale',
  retail: 'retail',
}

export default SHOP_TYPE
